import { ShareBaseAction } from 'sharebase/domain/sharebase.actions';
import { ActionService } from 'phoenix/services/actionService';
import { AclDatastore } from 'sharebase/dataStores/aclDatastore';
import { AnalyticsMenuItem } from 'sharebase-app/domain/analyticsMenuItem';
import { AppAction } from 'sharebase-app/components/_app/app.actions';
import { IAppAction } from 'sharebase/domain';
import { 
    PermissionType, 
    ShareBaseItem
} from 'phoenix/domain';
import { CommonUtilsService} from 'util/services';
import {
     TrackingService, 
     ActionRepository
} from 'sharebase/services';

export interface PermissionRequestPayload{
    item:ShareBaseItem|ShareBaseItem[];
    permission:PermissionType;
    targetAction:IAppAction;
}

export class DeferredPermissionMenuItem extends AnalyticsMenuItem {
    public permissions:PermissionType;
    constructor(
        utils:CommonUtilsService,
        $q:ng.IQService,
        private pxActionService:ActionService,
        sbTrackingService:TrackingService,
        private sbAclDatastore:AclDatastore,
        protected sbActionRepository:ActionRepository,
        public action:string, 
        public label:string, 
        public icon:string
    ){
        super(utils, $q, sbTrackingService, action, label, icon);
    }

    public clone(){
        let clone = new DeferredPermissionMenuItem(
            this.utils, 
            this.$q,
            this.pxActionService,
            this.sbTrackingService,
            this.sbAclDatastore,
            this.sbActionRepository,
            this.action,
            this.label,
            this.icon
        );

        return this.copyInstanceData(clone); 
    }
    
    public trigger(target, event:ng.IAngularEvent){
        let p = this.$q.resolve(true);
        let targets:any[] = Array.isArray(target) ? target : [target];

        if(angular.isDefined(this.permissions) && targets.every(t => angular.isDefined(t) && t !== null)){
            let checks = targets.map(t => this.sbAclDatastore.hasPermission(t, this.permissions));
            p = this.$q.all<boolean>(checks)
                .then(results => results.every(r => r === true));
        }

        return p.then(hasPermission => {
            if(hasPermission){
                super.trigger(target, event);
            }
            else {
                let permissionPayload:PermissionRequestPayload = {
                    item: target as ShareBaseItem,
                    permission: this.permissions,
                    targetAction: this
                }

                this.pxActionService.emit({
                    type: ShareBaseAction.RequestRight,
                    payload:permissionPayload
                }, event);
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/sharebase-app/domain/deferredPermissionMenuItem.ts